/* istanbul ignore file */
import { RECEIVE_CONTEST_EVENT_PRIZE_PAYOUTS, FETCH_CONTEST_EVENT_PRIZE_PAYOUTS } from './constants';
import { CFAuthGetRef } from 'auth';
import { locations } from '../../common/redux/action_locations';

export const receivedContestEventPrizePayouts = (contestEventPrizePayouts, data) => {
  const key = contestEventPrizePayouts && data.additionalParams ? 'contestEventPrizePayouts-' + data.additionalParams : null;
  
  return {
    type: RECEIVE_CONTEST_EVENT_PRIZE_PAYOUTS,
    contestEventPrizePayouts,
    key
  }
}

export const fetchContestEventPrizePayouts = (filters, additionalParams) => {
	return {
    type: FETCH_CONTEST_EVENT_PRIZE_PAYOUTS,
    fetchCall: fetchContestEventPrizePayoutsCall,
    receivedAction: receivedContestEventPrizePayouts,
    data: { locations, filters, additionalParams }
  }
}

export const fetchContestEventPrizePayoutsCall = (contestEventId) => {
  return CFAuthGetRef({
    url: `${process.env.REACT_APP_CONTEST_API_URL}/ContestEvents/${contestEventId}/ContestEventPrizePayouts`,
    params: null,
		originURL: process.env.PUBLIC_URL,
		loaderName: ''
	})
}

export const reducer = (state, { type, contestEventPrizePayouts, key }) => {
  switch (type) {
    case RECEIVE_CONTEST_EVENT_PRIZE_PAYOUTS:
      return {
        ...state,
        [key]: contestEventPrizePayouts
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/features/contests/redux/fetchContestEventPrizePayouts.js